
import { React } from 'react';
import { VscFiles } from "react-icons/vsc";
import { TiTick } from "react-icons/ti";
import { RxCross2 } from "react-icons/rx";
import { Link } from 'react-router-dom';




import DataTableReusable from '../data-table-reusable/DataTableReusable';
import './CsvJson.scss';
import CodesDescriptions from '../csv-json-info-pages/used-values/CodesDescriptons';

function CsvJson() {

  const commonHeaders = ['Category', 'Cars', 'LCV', 'HGV', 'Bikes'];

  const tables = [
    {
      title: 'Used Values',
      headers: commonHeaders,
      rows: [
        {
          label: (<Link to="/CsvJson/used-values-codes-descriptions">
            Codes and Descriptions
          </Link>), values: ['Tick', 'Tick', 'Tick', 'Tick']
        },
        {
          label: (<Link to="/CsvJson/used-values-used-prices">
            Used Prices
          </Link>), values: ['Tick', 'Tick', 'Tick', 'Tick']
        },
        {
          label: (<Link to="/CsvJson/used-values-mileage-calculation">
            Mileage Calculation Rules
          </Link>), values: ['Tick', 'Tick', 'Cross', 'Tick']
        },
        { label: (<Link to="/CsvJson/used-values-HGV-mileage-calculation-rules">
            HGV Mileage Calculation Rules
          </Link>), values: ['Cross', 'Cross', 'Tick', 'Cross'] },
      ],
    },
    {
      title: 'Used Values Live',
      headers: commonHeaders,
      rows: [
        {
          label: (<Link to="/CsvJson/used-values-live-published-sequence">
            Published Sequence
          </Link>), values: ['Tick', 'Cross', 'Cross', 'Cross']
        },
        {
          label: (<Link to="/CsvJson/used-values-live-trade-prices">
            Trade Prices
          </Link>), values: ['Tick', 'Cross', 'Cross', 'Cross']
        },
        {
          label: (<Link to="/CsvJson/used-values-live-comment-link">
            Comment Link
          </Link>), values: ['Tick', 'Cross', 'Cross', 'Cross']
        },
        {
          label: (<Link to="/CsvJson/used-values-live-comments">
            Comments
          </Link>), values: ['Tick', 'Cross', 'Cross', 'Cross']
        },
      ],
    },
    {
      title: 'Future Values',
      headers: commonHeaders,
      rows: [
        {
          label: (<Link to="/CsvJson/future-values-codes-and-descriptions">
            Codes and Descriptions
          </Link>), values: ['Tick', 'Tick', 'Tick', 'Tick']
        },
        {
          label: (<Link to="/CsvJson/future-values-future-prices">
            Future Prices
          </Link>), values: ['Tick', 'Tick', 'Tick', 'Tick']
        },
        {
          label: (<Link to="/CsvJson/future-values-smr">
            SMR
          </Link>), values: ['Tick', 'Tick', 'Cross', 'Cross']
        },
        {
          label: (<Link to="/CsvJson/future-values-price-per-mile">
            Price Per Mile
          </Link>), values: ['Tick', 'Cross', 'Cross', 'Cross']
        },
        {
          label: (<Link to="/CsvJson/future-values-age-mileage-calculation-rules">
            Age / Mileage Calculation Rules
          </Link>), values: ['Tick', 'Tick', 'Cross', 'Tick']
        },
      ],
    },
    {
      title: 'New Vehicle Data',
      headers: commonHeaders,
      rows: [
        {
          label: (<Link to="/CsvJson/new-vehicle-data-code-descriptions">
            Codes and Descriptions
          </Link>), values: ['Tick', 'Tick', 'Tick', 'Tick']
        },
        {
          label: (<Link to="/CsvJson/new-vehicle-data-new-price-options">
            New Prices & Options*
          </Link>), values: ['Tick', 'Tick', 'Tick*', 'Tick*']
        },
        {
          label: (<Link to="/CsvJson/new-vehicle-data-standard=equipment">
            Standard Equipment
          </Link>), values: ['Tick', 'Tick', 'Cross', 'Cross']
        },
        {
          label: (<Link to="/CsvJson/new-vehicle-data-option-description">
            Option Descriptions
          </Link>), values: ['Tick', 'Tick', 'Cross', 'Cross']
        },
        {
          label: (<Link to="/CsvJson/new-vehicle-data-technical-data">
            Technical Data
          </Link>), values: ['Tick', 'Tick', 'Cross', 'Tick']
        },
        {
          label: (<Link to="/CsvJson/new-vehicle-data-colour-and-trim-links">
            Colour & Trim Links
          </Link>), values: ['Tick', 'Tick', 'Cross', 'Cross']
        },
      ],
      note: '*Note: HGV and Bikes New Prices & Options products do not contain option information',
    },
    {
      title: 'New Vehicle Data Enhanced',
      headers: ['Category', 'Cars', 'LCV'],
      rows: [
        {
          label: (<Link to="/CsvJson/new-vehicle-data-enhanced-manufacturers">
            Manufacturers
          </Link>), values: ['Tick', 'Tick']
        },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-ranges">
            Ranges
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-models">
            Models
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-derivatives-and-codes">
            Derivatives & Codes
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-trims">
            Trims
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-NVD-body-style">
            NVD Body Style
          </Link>), values: ['Tick', 'Cross'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-body-style">
            Body Styles
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-drive-trains">
            Drive Trains
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-fuel-delivery">
            Fuel Delivery
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-fuel-types">
            Fuel Types
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-transmissions-types">
            Transmission
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-vehicle-sectors">
            Vehicle Sectors
          </Link>), values: ['Tick', 'Cross'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-model-years">
            Model Years
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-prices">
            Prices
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-selectable-options">
            Selectable Options
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-standard-equipment">
            Standard Equipment
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-category-descriptions">
            Category Descriptions
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-option-descriptions">
            Option Descriptions
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-pack-contents">
            Pack Contents
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-technical-descriptions">
            Technical Descriptions
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-technical-data">
            Technical Data
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-generic-descriptions">
            Generic Descriptions
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-generic-option-link">
            Generic Option Link
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-option-to-generic-category-link">
            Option to Generic Category Link
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-generic-status">
            Generic Status
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-colour-and-trim-links">
            Colour & Trim Links
          </Link>), values: ['Tick', 'Tick'] },
        { label:(<Link to="/CsvJson/new-vehicle-data-enhanced-colour-and-hood-links">
           Colour & Hood Links
          </Link>), values: ['Tick', 'Cross'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-option-relationships">
            Option Relationships
          </Link>), values: ['Tick', 'Cross'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-editions">
            Editions
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-vehicles-on-run-out">
            Vehicles On Run Out
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-new-vehicle-data-changes">
            New Vehicle Data Changes 
          </Link>), values: ['Tick', 'Tick'] },
        { label: (<Link to="/CsvJson/new-vehicle-data-enhanced-technical-data-changes">
            Technical Data Changes
          </Link>), values: ['Tick', 'Tick'] },
      ],
      // note: '*Note: As a subscriber of CAP ASCII Enhanced data you will require the NVD & Vehicle schemas, these will help you to organize and interpret the data found in each table.',
      // link: (
      //   <a href="/files/schemas.zip" download>
      //     <VscFiles className='product-download-icon' />
      //     Download Schemas
      //   </a>
      // ),
    },
    // {
    //   title: 'CAP - ASCII Images',
    //   headers: ['Category', 'Cars', 'LCV'],
    //   rows: [
    //     { label: 'Images Support File Layout', values: ['Tick', 'Tick'] }
    //   ],
    //   note: '*Note: HGV and Bikes New Prices & Options products do not contain option information',
    //     link: [
    //       <a href="/files/CapImages300.zip" download key="zip">
    //         <VscFiles className="product-download-icon" />
    //         Download Image Transfer Application
    //       </a>,
    //       <div>
    //  <a
    //         href="https://business.cap.co.uk/sites/default/files/public/image_ascii_download_application.pdf"
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         key="pdf"
    //       >
    //         <VscFiles className="product-download-icon" />
    //         Setup Guide for Images Download
    //       </a>
    //       </div>
    //    ,
    //     ],
    // },
    //   {
    //   title: 'CAP - Fleetnet Cross Reference',
    //   headers: ['Category', 'Cars', 'LCV'],
    //   rows: [
    //     { label: 'Cross Reference Layout', values: ['Tick', 'Tick'] }
    //   ],
    // }
  ];

  const renderIcon = (value) => {
    return value === 'Tick' ? <TiTick /> : <RxCross2 />
      ;
  };


  return (
    <div className='csv-json-container'>
      <h1 className='header-text'>JSON and CSV</h1>
      {/* 
      <h3 className='info-text'>Note: We’ve started the process of withdrawing the ASCII file format in favour of CSV. More information and support documentation can be found here  –
        and you can always discuss the migration process with your cap hpi Account Manager or call 0113 222 2007.</h3> */}

      <h1 className='header-text'> File Descriptions</h1>

      <p className='standard-text'>Our CSV and JSON files are sets of raw data that are used to populate customers’ own systems. cap-hpi has developed its range of data files not only in response to customers’ differing methods of data usage but also their common need for reliable, consistent data. Across the cap-hpi product range there are numerous data files from Current Values,
        Future Values through to New Vehicle Data. The below tables shows what vehicles types are available in each file.</p>

      <div>
        {tables.map((table, i) => (
          <DataTableReusable
            key={i}
            title={table.title}
            headers={table.headers}
            rows={table.rows}
            note={table.note}
            link={table.link}
          />
        ))}
      </div>
    </div>
  );
};

export default CsvJson
